import { currentEstateSelectors } from "@/modules/estate/currentEstate/currentEstateSlice";
import { selectEstateListItems } from "@/modules/estate/estateList/estateListSlice";
import { useAppSelector } from "@/store/store";

export const useEstateSelection = () => {
  const estates = useAppSelector(selectEstateListItems);
  const currentEstate = useAppSelector(
    currentEstateSelectors.selectCurrentEstate,
  );

  return { estates, currentEstate };
};
